<form [formGroup]="createForm">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <a [routerLink]="getFilePath(node)" routerLinkActive="active">
        <mat-icon class="presentation-mat-icon">insert_drive_file</mat-icon>
        <mat-label>{{ stripHtml(node.name) }}</mat-label>
      </a>
      <span class="spacer"></span>
      <div *ngIf="isInEditMode">
        <button mat-icon-button [matMenuTriggerFor]="menu2">
          <mat-icon class="panel-string">more_vert</mat-icon>
        </button>
        <mat-menu #menu2="matMenu">
          <div class="menu-div">
            <button class="menu-button" mat-menu-item (click)="copy(node)">
              <mat-icon
                class="menu-item"
                matTooltip="Copy"
                matTooltipPosition="right"
              >
                file_copy
              </mat-icon>
            </button>
          </div>
          <div class="menu-div">
            <button
              class="menu-button"
              mat-menu-item
              (click)="deleteFileOrFolder(node, false)"
            >
              <mat-icon
                class="menu-item"
                matTooltip="Delete"
                matTooltipPosition="right"
              >
                delete
              </mat-icon>
            </button>
          </div>
        </mat-menu>
      </div>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      class="has-children"
    >
      <a [routerLink]="getFilePath(node)" routerLinkActive="active">
        <mat-icon class="presentation-mat-icon">bookmark</mat-icon>
        <mat-label>{{ stripHtml(node.name) }}</mat-label>
      </a>
      <span class="spacer"></span>
      <button
        mat-icon-button
        matTreeNodeToggle
        [attr.aria-label]="'toggle' + stripHtml(node.name)"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      <div *ngIf="isInEditMode">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon class="panel-string">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div class="menu-div">
            <button
              class="menu-button"
              mat-menu-item
              (click)="changeNewFileNameVisibility(true, true, node)"
            >
              <mat-icon
                class="menu-item"
                matTooltip="{{
                  'components.wiki.sideNav.addCat.fullLabel' | translate
                }}"
                matTooltipPosition="right"
              >
                library_add
              </mat-icon>
            </button>
          </div>
          <div class="menu-div">
            <button
              class="menu-button"
              mat-menu-item
              (click)="changeNewFileNameVisibility(true, false, node)"
            >
              <mat-icon
                class="menu-item"
                matTooltip="{{
                  'components.wiki.sideNav.addPage.fullLabel' | translate
                }}"
                matTooltipPosition="right"
              >
                note_add
              </mat-icon>
            </button>
          </div>
          <div class="menu-div">
            <button class="menu-button" mat-menu-item (click)="copy(node)">
              <mat-icon
                class="menu-item"
                matTooltip="{{
                  'components.wiki.sideNav.copy.fullLabel' | translate
                }}"
                matTooltipPosition="right"
              >
                file_copy
              </mat-icon>
            </button>
          </div>
          <div class="menu-div">
            <button
              class="menu-button"
              mat-menu-item
              (click)="deleteFileOrFolder(node, true)"
            >
              <mat-icon
                class="menu-item"
                matTooltip="{{
                  'components.wiki.sideNav.delete.fullLabel' | translate
                }}"
                matTooltipPosition="right"
              >
                delete
              </mat-icon>
            </button>
          </div>
        </mat-menu>
      </div>
    </mat-tree-node>
  </mat-tree>
  <div *ngIf="isCreating && isInEditMode" class="create-div">
    <mat-form-field>
      <mat-label>{{
        "components.wiki.sideNav.newName.fullLabel" | translate
      }}</mat-label>
      <input formControlName="createInput" matInput autocomplete="off" />
      <button
        matSuffix
        mat-icon-button
        aria-label="Validate"
        (click)="createPageOrDir()"
      >
        <mat-icon class="v-align-middle">check</mat-icon>
      </button>
    </mat-form-field>
  </div>
</form>
